export default "__VITE_ASSET__9pIlUd3G__"